import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import { useLingui } from '@lingui/react';
import { useAppConfiguration } from '../hooks/useAppConfiguration';
import Collapsable from '../Collapsable';
import { mailCheck } from './mailcheck';

/**
 * @type {import('mailcheck').ISuggestion}
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const initialSuggestion = {
  address: '',
  domain: '',
  full: ''
};

/**
 *
 * @param {object} props
 * @param {string} props.email
 * @param {React.ReactNode} [props.className]
 * @param {React.ReactNode} [props.label]
 * @param {React.ReactNode} [props.buttonText]
 * @param {(email: string) => void} props.setEmail
 */
export function EmailSuggestion(_ref) {
  var _label, _buttonText;
  let {
    email,
    className,
    label,
    buttonText,
    setEmail
  } = _ref;
  const {
    i18n
  } = useLingui();
  const [suggestion, clear] = useEmailCheck(email);
  const {
    full
  } = suggestion;
  label = (_label = label) !== null && _label !== void 0 ? _label : i18n._('selfInspection.emailSuggestion.label');
  buttonText = (_buttonText = buttonText) !== null && _buttonText !== void 0 ? _buttonText : i18n._('selfInspection.emailSuggestion.buttonText');

  /**@type {React.MouseEventHandler<HTMLButtonElement>} */
  function onClickHandler(e) {
    e.preventDefault();
    setEmail(full);
    clear();
  }
  return /*#__PURE__*/_jsx(Collapsable, {
    closed: full === '',
    duration: 80,
    closeDelay: 0,
    children: /*#__PURE__*/_jsx("div", {
      className: cx('email-suggestion', className),
      children: /*#__PURE__*/_jsxs("span", {
        style: {
          opacity: full === '' ? 0 : 1
        },
        children: [/*#__PURE__*/_jsx("span", {
          children: i18n._('selfInspection.emailSuggestion.label', {
            email: full
          })
        }), ' ', /*#__PURE__*/_jsx("button", {
          className: cx('email-suggestion__button'),
          type: "button",
          onClick: onClickHandler,
          children: buttonText
        })]
      })
    })
  });
}

/**
 *
 * @param {string} email
 * @return {[import('mailcheck').ISuggestion, () => void]}
 */
export function useEmailCheck(email) {
  const {
    locale
  } = useAppConfiguration();
  const [suggestion, setSuggestion] = useState(initialSuggestion);
  useEffect(function emailChangeEffect() {
    mailCheck({
      locale,
      email,
      suggested: suggestion => {
        if (suggestion.address !== undefined) {
          setSuggestion(suggestion);
        }
      },
      empty() {
        setSuggestion(initialSuggestion);
      }
    });
  }, [email, locale]);
  function empty() {
    setSuggestion(initialSuggestion);
  }
  return [suggestion, empty];
}